import { usePage } from "@inertiajs/react"

interface AuthProps {
  [key: string]: unknown
  auth: {
    user: {
      is_admin: boolean
      is_full_access: boolean
      permissions: Record<string, boolean>
    }
  }
}

export function useNavPermissions() {
  const { auth } = usePage<AuthProps>().props
  const user = auth?.user
  if (!user) {
    return {
      isAdmin: false,
      isFullAccess: false,
      canViewCustomers: false,
      canViewCalendar: false,
      canSearch: false,
      hasActivityAccess: false,
      hasMarketingAccess: false,
      hasAccountingAccess: false,
      hasAdminAccess: false,
      canApproveDailyReports: false,
      canPrepareReports: false,
      canApproveTimeExpenses: false,
      canApproveTimeOff: false,
      canMktCategories: false,
      canManageDocs: false,
      canAddEmployee: false,
      canGpsAdmin: false,
      canViewVendors: false,
      canUploadDocs: false,
    }
  }

  const isAdmin = user.is_admin
  const isFullAccess = user.is_full_access
  const p = user.permissions || {}

  return {
    isAdmin,
    isFullAccess,
    canViewCustomers: isAdmin || !!p.viewCustomers,
    canViewCalendar: isAdmin || isFullAccess || !!p.viewCalendar,
    canSearch: isAdmin || !!p.peopleSearch || !!p.searchAllCases,
    hasActivityAccess:
      isAdmin ||
      !!(
        p.approveTimeExpenses ||
        p.approveDailyReports ||
        p.approveTimeOff ||
        p.prepareReports
      ),
    hasMarketingAccess:
      isAdmin || !!(p.mktCategories || p.projects || p.manageDocs),
    hasAccountingAccess:
      isAdmin ||
      !!(
        p.approveTimeExpenses ||
        p.payExpenses ||
        p.viewPayroll ||
        p.managePayments
      ),
    hasAdminAccess: isAdmin,
    canApproveDailyReports: isAdmin || !!p.approveDailyReports,
    canPrepareReports: isAdmin || !!p.prepareReports,
    canApproveTimeExpenses: isAdmin || !!p.approveTimeExpenses,
    canApproveTimeOff: isAdmin || !!p.approveTimeOff,
    canMktCategories: isAdmin || !!p.mktCategories,
    canManageDocs: isAdmin || !!p.manageDocs,
    canAddEmployee: isAdmin,
    canGpsAdmin: isAdmin,
    canViewVendors: isAdmin || isFullAccess,
    canUploadDocs: isAdmin || !!p.uploadDocs,
  }
}
